import React from "react";

export default function Items({ className }) {
  return (
    <svg
      width="100%"
      height="100%"
      x="0"
      y="0"
      viewBox="0 0 24 24"
      className={className}
    >
      <g>
        <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
          <path
            d="M1.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0zM4 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM2.25 5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0zM4 4.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5zM2.25 19a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0zM4 18.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5zM9.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75zM9.25 19a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75zM9.25 5a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H10A.75.75 0 0 1 9.25 5z"
            fill="currentColor"
            opacity="1"
            dataOriginal="currentColor"
            className=""
          ></path>
        </g>
      </g>
    </svg>
  );
}
